import React, { Component } from 'react';
import starFull from '../../../assets/images/star_full.svg';
import starEmpty from '../../../assets/images/star_empty.svg';

class FavoriteStar extends Component {
    _favOrUnfav = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.favOrUnfavArtist(this.props.artistId);
    };
    render() {
        return (
            <button className="ckp-timetable-entry-favorite">
                <img onClick={this._favOrUnfav} alt="Favorite" src={this.props.isFavorite ? starFull : starEmpty} />
            </button>
        );
    }
}

export default FavoriteStar;



// WEBPACK FOOTER //
// ./src/components/application/events/FavoriteStar.js